import {
  HospitalSummary,
  ICoordinate,
  IPickedCityInfo,
  IPickerOption
} from '@/schemas/register';

interface IState {
  selectedCity: IPickedCityInfo;
  // 当前定位坐标
  coordinate: ICoordinate;
  // 坐标获取失败默认兜底坐标
  defaultCoordinate: ICoordinate;
  cityList: IPickerOption[]; // picker 可选双列城市列表
  hospitalFirstDepartScrollTop?: number; // 医院科室页一级科室滚动位置
  getingLocation: boolean; // 正在获取定位中标识
}

const register = {
  state: {
    selectedCity: {
      cityCode: '410000',
      cityName: '河南',
      areaCode: '-1',
      areaName: '不限',
      enableRegister: true
    },
    coordinate: {
      longitude: 0,
      latitude: 0
    },
    defaultCoordinate: {
      // 郑州
      longitude: 113.62,
      latitude: 34.75
    },
    cityList: [],
    hospitalFirstDepartScrollTop: 0,
    getingLocation: true
  } as IState,

  reducers: {
    // 纯函数来改变 state
    updateState(state, payload) {
      return {
        ...state,
        ...payload
      };
    },
    updateCoordinate(state, payload: ICoordinate) {
      return {
        ...state,
        coordinate: payload
      };
    },
    updateFirstDepartScrollTop(state, payload: number) {
      return {
        ...state,
        hospitalFirstDepartScrollTop: payload
      };
    }
  },

  effects: (dispatch) => ({
    // 异步请求
  })
};

export default register;
